import HTTP from "../../utility/http";
import { asyncHandler } from "@/utility/async";

const state = {};

const getters = {};

const actions = {
  async add_photo(context, data) {
    return await asyncHandler(
      HTTP({ url: "/slideshow/add-photo", method: "POST", data })
    );
  },

  async remove_photo(context, data) {
    return await asyncHandler(
      HTTP({ url: "/slideshow/remove-photo", method: "POST", data })
    );
  },

  async save_slideshow(context, data) {
    const url = data.id ? "/slideshow/" + data.id : "/slideshow";
    const method = data.id ? "PUT" : "POST";
    return await asyncHandler(HTTP({ url, method, data }));
  },

  async get_displayGroups(context, data) {
    return await asyncHandler(
      HTTP({
        url: "display-group/date-and-outfitter",
        data: data,
        method: "POST",
      })
    );
  },

  async get_slideshows(context, data) {
    return await asyncHandler(
      HTTP({
        url: "slideshow/outfitter",
        data: data,
        method: "POST",
      })
    );
  },

  async get_slideshow(context, id) {
    return await asyncHandler(
      HTTP({
        url: "slideshow/get/" + id,
        method: "GET",
      })
    );
  },

  async delete(context, data) {
    return await asyncHandler(
      HTTP({ url: "slideshow/delete/" + data.id, method: "GET" })
    );
  },
};

const mutations = {};

export default {
  namespaced: true,
  actions,
  mutations,
  getters,
  state,
};
